import Vue from 'vue'
import Router from 'vue-router'
import auth from './services/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/registrar',
      name: 'registrar',
      component: () => import(/* webpackChunkName: "login" */ './views/Registrar.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "logout" */ './views/Logout.vue')
    },
    {
      path: '/usuarios',
      name: 'usuarios',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "cadastro" */ './views/Usuarios/index.vue')
    },
    {
      path: '/usuarios/editar/:id',
      name: 'usuariose',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "empresas" */ './views/Usuarios/formulario.vue')
    },
    {
      path: '/usuarios/criar',
      name: 'usuariosc',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "empresas" */ './views/Usuarios/formulario.vue')
    },
    {
      path: '/departamentos',
      name: 'departamentos',
      meta: { requiresAuth: true },
      component: () => import('./views/Departamentos/index.vue')
    },
    {
      path: '/departamentos/editar/:id',
      name: 'departamentose',
      meta: { requiresAuth: true },
      component: () => import('./views/Departamentos/formulario.vue')
    },
    {
      path: '/departamentos/criar',
      name: 'departamentosc',
      meta: { requiresAuth: true },
      component: () => import('./views/Departamentos/formulario.vue')
    },
    {
      path: '/profissionais',
      name: 'profissionais',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissionais/index.vue')
    },
    {
      path: '/profissionais/editar/:id',
      name: 'profissionaise',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissionais/formulario.vue')
    },
    {
      path: '/profissionais/criar',
      name: 'profissionaisc',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissionais/formulario.vue')
    },
    {
      path: '/profissionais/deletar/:id',
      name: 'profissionaisd',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissionais/deletar.vue')
    },
    {
      path: '/requisicoes',
      name: 'requisicoes',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes/index.vue')
    },
    {
      path: '/requisicoes/criar',
      name: 'requisicoesc',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes/formulario.vue')
    },
    {
      path: '/requisicoes/editar/:id',
      name: 'requisicoese',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes/formulario.vue')
    },
    {
      path: '/requisicoescliente',
      name: 'requisicoescliente',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes_cliente/index.vue')
    },
    {
      path: '/requisicoescliente/criar',
      name: 'requisicoesclientec',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes_cliente/formulario.vue')
    },
    {
      path: '/requisicoescliente/editar/:id',
      name: 'requisicoesclientee',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes_cliente/formulario.vue')
    },
    {
      path: '/requisicoesbaixa',
      name: 'requisicoesbaixa',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes_baixa/index.vue')
    },
    {
      path: '/requisicoesbaixa/editar/:id/:empresa',
      name: 'requisicoesbaixae',
      meta: { requiresAuth: true },
      component: () => import('./views/Requisicoes_baixa/formulario.vue')
    },
    {
      path: '/permissoes',
      name: 'permissoes',
      meta: { requiresAuth: true },
      component: () => import('./views/Permissoes/index.vue')
    },
    {
      path: '/permissoes/editar/:nome',
      name: 'permissoese',
      meta: { requiresAuth: true },
      component: () => import('./views/Permissoes/formulario.vue')
    },
    {
      path: '/plano',
      name: 'plano',
      meta: { requiresAuth: true },
      component: () => import('./views/Plano/index.vue')
    },
    {
      path: '/plano/criar',
      name: 'planoc',
      meta: { requiresAuth: true },
      component: () => import('./views/Plano/formulario.vue')
    },
    {
      path: '/plano/editar/:id',
      name: 'planoe',
      meta: { requiresAuth: true },
      component: () => import('./views/Plano/formulario.vue')
    },
    {
      path: '/veiculo',
      name: 'veiculo',
      meta: { requiresAuth: true },
      component: () => import('./views/Veiculos/index.vue')
    },
    {
      path: '/veiculo/criar',
      name: 'veiculoc',
      meta: { requiresAuth: true },
      component: () => import('./views/Veiculos/formulario.vue')
    },
    {
      path: '/veiculo/editar/:id',
      name: 'veiculoe',
      meta: { requiresAuth: true },
      component: () => import('./views/Veiculos/formulario.vue')
    },
    {
      path: '/usuariosprofissionais',
      name: 'up',
      meta: { requiresAuth: true },
      component: () => import('./views/Usuarios_profissionais/index.vue')
    },
    {
      path: '/usuariosprofissionais/criar',
      name: 'upc',
      meta: { requiresAuth: true },
      component: () => import('./views/Usuarios_profissionais/formulario.vue')
    },
    {
      path: '/usuariosprofissionais/editar/:id',
      name: 'upe',
      meta: { requiresAuth: true },
      component: () => import('./views/Usuarios_profissionais/formulario.vue')
    },
    {
      path: '/profissionaisveiculos',
      name: 'pv',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissional_veiculos/index.vue')
    },
    {
      path: '/profissionaisveiculos/criar',
      name: 'pvc',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissional_veiculos/formulario.vue')
    },
    {
      path: '/profissionaisveiculos/editar/:id',
      name: 'pve',
      meta: { requiresAuth: true },
      component: () => import('./views/Profissional_veiculos/formulario.vue')
    },
    {
      path: '/fornecedores',
      name: 'fornecedores',
      meta: { requiresAuth: true },
      component: () => import('./views/Fornecedores/index.vue')
    },
    {
      path: '/fornecedores/criar',
      name: 'fornecedoresc',
      meta: { requiresAuth: true },
      component: () => import('./views/Fornecedores/formulario.vue')
    },
    {
      path: '/fornecedores/editar/:id',
      name: 'fornecedorese',
      meta: { requiresAuth: true },
      component: () => import('./views/Fornecedores/formulario.vue')
    },
    {
      path: '/fornecedor',
      name: 'fornecedor',
      meta: { requiresAuth: true },
      component: () => import('./views/Fornecedores/formulario1.vue')
    },
    {
      path: '/usuariosfornecedores',
      name: 'uf',
      meta: { requiresAuth: true },
      component: () => import('./views/Usuarios_fornecedores/index.vue')
    },
    {
      path: '/usuariosfornecedores/criar',
      name: 'ufc',
      meta: { requiresAuth: true },
      component: () => import('./views/Usuarios_fornecedores/formulario.vue')
    },
    {
      path: '/usuariosfornecedores/editar/:id',
      name: 'ufe',
      meta: { requiresAuth: true },
      component: () => import('./views/Usuarios_fornecedores/formulario.vue')
    },
    {
      path: '/empresafornecedores',
      name: 'ef',
      meta: { requiresAuth: true },
      component: () => import('./views/Empresas_fornecedores/formulario.vue')
    },
    {
      path: '/relatorios',
      name: 'relatorios',
      meta: { requiresAuth: true },
      component: () => import('./views/Relatorios/lancamentos.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!auth.needLogin(to)) return next()

  return next({
    path: '/login',
    query: { redirect: to.fullPath }
  })
})

export default router
